import isEqual from "lodash/isEqual";

const mixAdd = {
    data() {
        return {
            disabled: false,
            product_res: {},
            now_variant: {},
            variant: [],
            now_variant_list: [], //[{},{}]遇到需要特殊处理的属性需要保存多个已选变种
            add_cart_list: [], //遇到需要特殊处理的属性需要保存多个已选变种加购信息
            add_cart_data: {
                product_id: null,
                quantity: 1,
            },
            special_attrs_value: [],//特殊属性有的可选options
            search_add_id_on: false, //控制第一次进来时不在url上拼接变种id
            min_price_product: {}
        }
    },
    methods: {
        according_id(variant_id) {
            if (!variant_id || !this.mix_variants_detail.length) return false;
            this.mix_variants_detail.some((item) => {
                if (item.ID == variant_id) {
                    this.variant.forEach((variant_item) => {
                        // attrs 可能为空
                        item.attrs?.some((attrs_item) => {
                            if (variant_item.name == attrs_item.name) {
                                variant_item.value = attrs_item.value;
                                return true;
                            }
                        });
                    });
                }
            });
        },
        get_min_price_product(product = {}) {
            let { min_price = 0 } = product;
            if (!this.mix_variants_detail.length) return false;
            this.mix_variants_detail.some(item => {
                let { price } = item;
                if (Number(price) == Number(min_price)) {
                    this.min_price_product = item;
                    return true;
                }
            })
        },
        create_attrs() {
            let index_count = -1;
            this.variant = [];
            this.now_variant_list = [];
            this.add_cart_list = [];
            this.product.variant_attrs.forEach((item, index) => {
                index_count++;
                //当有需要特殊处理的属性，并且循环到这一条的时候,改变商品原有的属性,按照特殊处理的规则重新设定属性名
                //index_count是由于属性重新绑定后数组下标发生变化所以要统计
                if (
                    this.has_special_attrs &&
                    this.$store.state.special_attr_key == item.name.toLowerCase()
                ) {
                    //用name小写去取对象
                    let special_attr =
                        this.$store.state.special_attrs[item.name.toLowerCase()];
                    if (!special_attr || !special_attr.length) return;
                    special_attr.forEach((special_attr_item, sub_index) => {
                        //改变商品字段中的属性
                        if (sub_index > 0) {
                            index_count++;
                            if (!this.product_res.variant_attrs[index_count] || !this.product_res.variant_attrs[index_count].special_native_name) {
                                this.product_res.variant_attrs.splice(index_count, 0, {
                                    ...item,
                                    name: special_attr_item.name,
                                    special_native_name: item.name,
                                    special_index: sub_index,
                                });
                            }
                            //调色板属性采用一样的逻辑
                            if (this.palette_attrs && this.palette_attrs.length) {
                                this.palette_attrs.splice(index_count, 0, {
                                    ...this.palette_attrs[index_count - 1],
                                    name: special_attr_item.name,
                                    special_native_name: item.name,
                                    special_index: sub_index,
                                });
                            }
                        } else {
                            //保留他原始的name
                            if (!this.product_res.variant_attrs[index_count].special_native_name) {
                                this.product_res.variant_attrs[index_count].special_native_name =
                                    item.name;
                                this.product_res.variant_attrs[index_count].name =
                                    special_attr_item.name;
                            }
                            //调色板属性采用一样的逻辑
                            if (this.palette_attrs && this.palette_attrs.length) {
                                this.palette_attrs[index_count].name = special_attr_item.name;
                                this.palette_attrs[index_count].special_native_name = item.name;
                                this.palette_attrs[index_count].special_index = sub_index;
                            }
                        }
                        //现有变种列表初始化时都为商品变种第一个
                        if (!this.mix_variants_detail.length) return false;
                        this.now_variant_list.push(this.mix_variants_detail[0]);
                        //现有加购列表初始化时都为商品变种第一个
                        this.add_cart_list.push({
                            quantity: 1,
                            product_id: this.product.ID,
                            variant_id: this.mix_variants_detail[0].ID,
                        });
                        //添加绑定属性
                        this.variant.push({
                            name: special_attr_item.name,
                            value: item.value[0],
                        });
                    });
                } else {
                    this.variant.push({
                        name: item.name,
                        value: item.value[0],
                    });
                }
            });
        },
        find_variant(newV, map_obj = {}) {
            let { map_key, map_val } = map_obj;
            if (!this.mix_variants_detail.length) return false;
            return this.mix_variants_detail.find((item) => {
                // attrs 可能为空
                return item.attrs?.every((subitem, index) => {
                    return newV.some((lowitem) => {
                        // 所有原始键名转小写
                        if (map_key && map_val && map_key == subitem.name.toLowerCase()) {
                            return map_val == lowitem.name && lowitem.value == subitem.value;
                        } else {
                            return (
                                lowitem.name == subitem.name && lowitem.value == subitem.value
                            );
                        }
                    });
                });
            });
        },
    },
    computed: {
        mix_all_disable() {
            //判断商品是否全部售空，默认为false;
            let onOff = false
            if (this.mix_variants_detail.length) {
              onOff = !this.mix_variants_detail.some((item) => {
                //只要有一个变种商品不为false 则该商品不为全部售空;
                if (item.buy_able !== false) return true
              })
            } else if (this.product.buy_able === false) {
              onOff = true
            }
            return onOff
        },
        mix_variants_detail() {
            let mix_variants_detail = []
            let { variants, variants_detail } = this.product
            if (variants && variants.length) {
              mix_variants_detail = variants
            } else if (variants_detail && variants_detail.length) {
              mix_variants_detail = variants_detail
            }
            return mix_variants_detail
          },
        mix_now_image_data() {
            let { feature_image, gallery } = this.now_variant;
            let { feature_image : product_res_feature_image } = this.product_res
            let data = (feature_image && Object.keys(feature_image).length && feature_image) || (product_res_feature_image && Object.keys(product_res_feature_image).length && product_res_feature_image) || (gallery && gallery.length && gallery[0]) || null;
            return data;
        },
        search_join_id() {
            return this.search_add_id_on && this.mixin_in_product && window.location.pathname.includes('/products');
        },
        has_special_attrs() {
            if (this.$store.state.theme_name !== 'athena') return false;
            let { variant_attrs } = this.product;
            let Obj_key = [];
            let special_attrs = this.$store.state.special_attrs;
            //special_attrs 有值
            if (special_attrs && Object.keys(special_attrs).length) {
                Obj_key = Object.keys(special_attrs);
            }
            if (!variant_attrs || !variant_attrs.length || !Obj_key.length)
                return false;
            //special_attrs中需要特殊处理的数组有长度,并记录下有长度的那个name
            let res = Obj_key.find((item) => {
                return special_attrs[item].length;
            });
            if (!res) return false;
            //确认special_attrs中有长度切需要特殊处理的字段在商品属性中也有存在
            return variant_attrs.some((item) => {
                let { name, value } = item;
                //转小写时候判断特殊处理字段里是否包含
                name = name.toLowerCase();
                if (Obj_key.includes(name)) {
                    //存下特殊属性中的可选值
                    this.special_attrs_value = value;
                    //存下商品中转小写之前的属性值,和special_attrs中数组的长度
                    this.$store.commit("change_special_attr_info", {
                        num: special_attrs[res].length,
                    });
                    return true;
                }
            });
        },
        computed_price() {
            let { min_price } = this.product;
            let price = { price: 0, regular_price: 0, buy_able: true, min_price: min_price || 0 };
            if (this.now_variant_list && this.now_variant_list.length) {
                this.now_variant_list.forEach((item) => {
                    price.price = price.price + (item.price - 0);
                    price.regular_price = price.regular_price + (item.regular_price - 0);
                    if (!item.buy_able) price.buy_able = false;
                });
            } else {
                price.price = this.now_variant.price - 0 || min_price || 0;
                price.regular_price = this.now_variant.regular_price - 0 || 0;
                price.buy_able = this.now_variant.buy_able;
            }
            if (price.regular_price > price.price) {
                price.agio = price.regular_price - price.price;
                price.percentage = ((price.agio / price.regular_price) * 100) | 0;
            }
            return price;
        },
        // 产品卡片显示主图
        mainImg() {
            if (this.isShowMainImg && !this.palette_config) {
              return this.product_res?.gallery?.[0] || {}
            }
            return {}
        },
    },
    watch: {
        product: {
            handler(newV, oldV) {
                //要使用该mixins 则必须有product字段为商品信息!!!!;
                if (!newV || isEqual(newV, oldV)) return;
                let copy_product = JSON.stringify(newV);
                this.product_res = JSON.parse(copy_product);
                this.now_variant = JSON.parse(copy_product);
                this.add_cart_data.product_id = newV.ID;
                if (newV.variant_attrs && newV.variant_attrs.length) {
                    this.create_attrs();
                    //获取一下最小价格的变种商品信息
                    this.get_min_price_product(newV)
                    //所有循环结束后将变种信息
                    let onOff = this.mixin_in_product && window.location.pathname.includes('/products');
                    if (this.now_variant.ID !== this.min_price_product.ID && !onOff) {
                        setTimeout(() => {
                            this.according_id(this.min_price_product.ID);
                        }, 0);
                    }

                }
            },
            immediate: true
        },
        'add_cart_data.quantity'(newV) {
            if (this.add_cart_list && this.add_cart_list.length) {
                this.add_cart_list = this.add_cart_list.map(item => {
                    item.quantity = newV;
                    return item;
                })
            }
            //组合商品时会有这个方法
            if (this.add_cart_payload) this.add_cart_payload();
        },
        variant: {
            handler(newV, oldV) {
                if(!newV.length) return;
                if (this.has_special_attrs) {
                    let { special_attrs } = this.$store.state;
                    for (const key in special_attrs) {
                        let special_attr = special_attrs[key];
                        if (!special_attr.length) return;
                        // 若该mixin是商品详情页的mixin 则将当前选中的商品属性存入vuex，供组合商品跟随该变种使用
                        if (this.mixin_in_product) this.$store.commit('change_variant_list', newV);
                        //组合商品
                        special_attr.forEach((attr_item, attr_index) => {
                            let item = this.find_variant(newV, {
                                map_key: this.$store.state.special_attr_key,
                                map_val: attr_item.name,
                            });
                            if (item) {
                                this.now_variant_list.splice(attr_index, 1, item);
                                this.now_variant = { ...this.now_variant, ...item };
                                this.add_cart_list[attr_index].variant_id = item.ID;
                                //虽然此时不需要用到add_cart_data,但任然更新一下他的variant_id,避免完全的加购失败;
                                this.$set(this.add_cart_data, 'variant_id', item.ID);
                            } else {
                                this.now_variant_list.splice(attr_index, 1, { ...item, buy_able: false });
                            }
                        });
                    }
                } else {
                    let item = this.find_variant(newV);
                    if (item) {
                        // 如果变种商品有图片则切换轮播图
                        this.now_variant = { ...this.now_variant, ...item };
                        if (item.feature_image && item.feature_image.ID) {
                            this.$store.dispatch(
                                "change_feature_image_id",
                                item.feature_image.ID
                            );
                        } else {
                            this.$store.dispatch("change_feature_image_id", 0);
                        }
                        if (this.search_join_id) {
                            window.history.replaceState(
                                {},
                                "",
                                this.replaceSearch("variant", item.ID, true)
                            );
                        } else {
                            this.search_add_id_on = true;
                        }
                        this.add_cart_data.variant_id = item.ID;
                        this.stock = true;
                    } else {
                        this.now_variant = { ...this.now_variant, buy_able: false };
                        this.now_variant.buy_able = false;
                        this.$store.dispatch("change_feature_image_id", 0);
                        this.stock = false;
                    }
                }
                //组合商品时会有这个方法
                if (this.add_cart_payload) this.add_cart_payload();
            },
            immediate: true,
            deep: true,
        },
    }

}
export default mixAdd;
